import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bfb84f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification__title"
}
const _hoisted_2 = {
  key: 0,
  class: "notification__content"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        isOpen: true,
        onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
        width: "700px",
        height: "80%"
      }, {
        header: _withCtx(() => [
          (_ctx.notification)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.notification.title), 1))
            : _createCommentVNode("", true)
        ]),
        body: _withCtx(() => [
          (_ctx.notification)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_TUIViewer, {
                  modelValue: _ctx.notification.description
                }, null, 8, ["modelValue"]),
                (_ctx.notification.imageNotification)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.notification.imageNotification,
                      alt: "Imagem da notificação",
                      class: "notification__image"
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}